import { Card, Row, Col, Form } from "react-bootstrap";
export default function ErxHeader({ bp, doctor, patient }) {
  // console.log(bp);
  return (
    <>
      <Card border="primary" className="mb-3">
        <Card.Body>
          <Row>
            <Col>
              <strong>{doctor.doctorName},</strong> <br />
              <span> {doctor.degree}</span>
            </Col>
            <Col>
              <div className="text-end">
                {/* <h5>Posd Detail</h5> */}
                <strong>{bp.bp[0].bp_name}</strong>
                <br />
                <strong>{bp.bpBrName}</strong>
                <address>{bp.address}</address>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card border="primary" className="mb-3">
        <Card.Body>
          <Row xs={2} sm={2} md={2} lg={2}>
            <Col xs={8} sm={8} md={8} lg={8}>
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm={3}>
                  Patient
                </Form.Label>
                <Col sm={9}>
                  <Form.Control
                    plaintext
                    readOnly
                    defaultValue={patient.first_name + " " + patient.last_name}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col xs={4} sm={4} md={4} lg={4}>
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm={3}>
                  Age
                </Form.Label>
                <Col sm={9}>
                  <Form.Control />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row xs={2} sm={2} md={4}>
            <Col>
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm={3} md={6}>
                  Weight
                </Form.Label>
                <Col sm={9} md={6}>
                  <Form.Control />
                </Col>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm={3} md={6} title="Blood Pressure">
                  BP
                </Form.Label>
                <Col sm={9} md={6}>
                  <Form.Control />
                </Col>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Row} className="mb-3">
                <Form.Label column sm={3} md={6} title="Blood Group">
                  B Group
                </Form.Label>
                <Col sm={9} md={6}>
                  <Form.Control />
                </Col>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Row} className="mb-3">
                <Form.Label
                  className="text-nowrap"
                  column
                  sm={3}
                  md={6}
                  title="Oxygen Saturation"
                >
                  Saturation
                </Form.Label>
                <Col sm={9} md={6}>
                  <Form.Control />
                </Col>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
}
